import React from 'react';
import ClinicPersonnelTable from 'components/shared/ClinicPersonnelTable';
import { Box, useMediaQuery } from '@mui/material';
import { displayedPracticeRoles } from 'utils/resources/PracticeRoles';

export const PersonnelTable = ({
  people,
  deletePerson,
  openModal,
  allRoleOptions,
}) => {
  const largeScreen = useMediaQuery('(min-width:800px)');

  return (
    <ClinicPersonnelTable
      people={people}
      openModal={openModal}
      removePerson={deletePerson}
      columns={[
        {
          cellKey: 'name',
          label: 'Name',
          align: 'left',
          CellComponent: ({ person }) => {
            const { vetDegree, firstName, lastName } = person;
            const showDegree =
              vetDegree && ['dvm', 'vmd'].includes(vetDegree.toLowerCase());

            const suffix = showDegree ? `, ${vetDegree}` : '';
            const fullName = `${firstName} ${lastName}`.trim();

            return `${fullName}${suffix}`;
          },
        },
        {
          cellKey: 'ownerPercentage',
          label: 'Ownership %',
          className: 'ownership',
          align: 'right',
          CellComponent: ({ person }) => (
            <Box component="span">
              {person.ownerPercentage && `${person.ownerPercentage}%`}
            </Box>
          ),
        },
        {
          cellKey: 'vetLicenseNumber',
          label: 'Vet License #',
          align: 'right',
          className: 'license-number',
          includeEllipsis: largeScreen,
          CellComponent: null,
        },
        {
          cellKey: 'email',
          label: 'Email',
          align: 'left',
          className: 'email',
          includeEllipsis: largeScreen,
          CellComponent: null,
        },
        {
          cellKey: 'practiceRoles',
          label: 'Practice Role(s)',
          align: 'left',
          className: 'practice-roles',
          includeEllipsis: largeScreen,
          CellComponent: ({ person }) => (
            <Box component="span" textTransform="capitalize">
              {displayedPracticeRoles(allRoleOptions, person)}
            </Box>
          ),
        },
        {
          cellKey: 'actions',
          label: 'Actions',
          align: 'center',
          component: null,
        },
      ]}
    />
  );
};
